import { z } from 'zod'

const DEFAULT_SESSION_USER_NAME = 'Usuário'

const sessionUserNameSchema = z.preprocess((value) => {
  if (typeof value === 'string' && value.trim()) {
    return value.trim()
  }

  return DEFAULT_SESSION_USER_NAME
}, z.string())

export const authUserSchema = z.object({
  id: z.string(),
  name: z.string(),
  initials: z.string(),
  email: z.string().optional(),
  phone: z.string().optional(),
  cpf: z.string().optional(),
  onboardingRequired: z.boolean(),
})

export const sessionDataSchema = z.object({
  user_id: z.string(),
  user_name: sessionUserNameSchema,
  access_token: z.string(),
  refresh_token: z.string().optional(),
  expires_in: z.number(),
  onboarding_required: z.boolean().default(false),
})

export const providerLoginResponseSchema = z.object({
  data: sessionDataSchema,
})

export const simpleMessageResponseSchema = z.object({
  message: z.string(),
})

export const validateRecoveryCodeResponseSchema = z.object({
  data: z.object({
    valid: z.boolean(),
  }),
})

export const refreshSessionResponseSchema = z.object({
  data: sessionDataSchema.omit({ refresh_token: true, onboarding_required: true }).extend({
    onboarding_required: z.boolean().default(false),
  }),
})

export type AuthUser = z.infer<typeof authUserSchema>
export type AuthSessionData = z.infer<typeof sessionDataSchema>
export type ProviderLoginResponse = z.infer<typeof providerLoginResponseSchema>
export type SimpleMessageResponse = z.infer<typeof simpleMessageResponseSchema>
export type ValidateRecoveryCodeResponse = z.infer<typeof validateRecoveryCodeResponseSchema>
export type RefreshSessionResponse = z.infer<typeof refreshSessionResponseSchema>
